module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAWCAMAAAD3n0w0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABIUExURUdwTBVr9xhs9Rdr+Rdr9hds9hhs9gZz/xhs9Rdr9Rtt+hds9hds9Rds9hhs9Rds9Rhr9hds9hdr9Rhs9BVq+Bdq9Rds9hhs9WZHTTQAAAAXdFJOUwAa0QlCld8E8IMQ+l7JpedrU7x2JC6ye9UVUQAAAMRJREFUGNNtkNuSxCAIRPEKSozGXPj/P13i7FaZzPKCHAq6BeAZS+TgXsxLSBQeCDdbAFKcmSlcY8bVzoziaSpFWabZElE7oftRmTx0+ZwESWRVbNdRujxMdN/IopEx1kQuB+XS5yGbl4yIm4SFA3y0rPzGx2fdb1j7JUmjkwP1GchoUw4vmiETk2zgLFfSHcjtHsktHbcHH0Z+/O4vTtn/oYnVSCLueaZB1ibNP++JS5Wve6robfAqr705UmT/VsttP+EHHYQJGeu90U0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header/select-title5.png
// module id = vfqK
// module chunks = 0